export const TITLES = {
  BASE: 'My OPP - Online Payment Platform',
  ACCOUNT: 'Account',
  ACCOUNT_AND_SETTINGS: 'Account',
  ACTIVATE_ACCOUNT: 'Activate your account',
  AUTHENTICATE: 'Authenticate',
  AUTHENTICATING: 'Authenticating',
  BALANCE_DETAILS: 'Your balance breakdown',
  ADD_BALANCE: 'Add balance',
  CHANGELOG: `Release notes`,
  CREATE_TICKET: 'Create ticket',
  DASHBOARD: 'Dashboard',
  DELETE_ACCOUNT: 'Delete merchant account',
  EVENTS: 'System events',
  FORGOT_PASSWORD: 'Forgot your password?',
  KEYBOARD_SHORTCUTS: 'Keyboard shortcuts',
  LEAVE_FEEDBACK: 'Leave feedback',
  LOGIN: 'Login',
  MERCHANTS: 'Merchants',
  MESSAGE_CENTER: 'Message center',
  MESSAGES_AND_NOTIFICATIONS: 'Messages & Notifications',
  NOTIFICATIONS: 'Notifications',
  SETTLEMENTS: 'Payouts',
  SETTLEMENT: 'Payout',
  PROFILE: 'Your merchant account',
  PROFILE_AND_SETTINGS: 'Your account & settings',
  RECENT_UPDATES: 'Recent updates',
  REFUNDS: 'Refunds',
  RESET_PASSWORD: 'Set your password',
  SECURITY: 'Security settings',
  SETTINGS: 'Preferences',
  SPECIFICATIONS: 'Specifications',
  SUPPORT: 'Help & Support',
  SUPPORT_CENTER: 'Help & Support',
  SUPPORT_AND_TICKETS: 'Support',
  SUCCESS: 'Success',
  SWITCH_MERCHANT: 'Switch merchant account',
  TRANSACTIONS: 'Transactions',
  TRANSACTION: 'Transaction',
  PURCHASES: 'Purchases',
  PURCHASE: 'Purchase',
  YOUR_ACCOUNT: 'Your account',
  YOUR_DASHBOARD: 'Your dashboard',
  SUPPORT_OVERVIEW: 'Support',
  NO_INTERNET_CONNECTION: 'No internet connection'
};
